import React, { useEffect, useState } from "react";
import { Box, Typography, Stack } from "@mui/material";
import AboveTheCloudsSVG from "../../../assets/above_the_clouds.svg";
import ImageBackground from "../../../assets/session_summaries_background.svg";
import PulseBurst from "elements/PulseBurst";
import { keyframes } from "@emotion/react";
import { useTheme } from "@mui/material/styles";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const GeneratingIndicator = () => {
  const [visibleSteps, setVisibleSteps] = useState([]);
  const theme = useTheme();

  const steps = [
    "Reviewing appointment transcript",
    "Ensuring note align with clinical documentation standards",
    "Adding goals from the client's treatment plan",
    "Incorporating data collected during appointment",
  ];

  useEffect(() => {
    if (visibleSteps.length < steps.length) {
      const timeout = setTimeout(() => {
        setVisibleSteps((prev) => [...prev, prev.length]);
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [visibleSteps]);

  return (
    <Stack sx={{ width: "100%", mb: 11 }}>
      <Box
        sx={{
          backgroundColor: theme.palette.success.background,
          borderRadius: "12px",
          padding: "16px 24px",
          marginBottom: "12px",
          display: "flex",
          alignItems: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Stack
          direction="column"
          sx={{
            width: "100%",
            alignItems: "flex-start",
            gap: "12px",
          }}
        >
          {/* Title row with dot */}
          <Stack direction="row" alignItems="center" sx={{ mb: 2 }}>
            <PulseBurst />
            <Typography variant="body2" sx={{ color: theme.palette.success.dark }}>
              Generating your session note
            </Typography>
          </Stack>

          {/* Steps list */}
          <Box>
            {visibleSteps.map((stepIndex) => (
              <Typography
                key={stepIndex}
                variant="caption"
                sx={{
                  color: theme.palette.success.dark,
                  animation: `${fadeIn} 0.5s ease-out`,
                  textAlign: "left",
                }}
              >
                {steps[stepIndex]}
              </Typography>
            ))}
          </Box>
        </Stack>

        {visibleSteps.length >= 4 && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              height: "100%",
              width: "32%",
              backgroundImage: `url(${ImageBackground})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right center",
            }}
          />
        )}

        {visibleSteps.length >= 4 && (
          <Box
            component="img"
            src={AboveTheCloudsSVG}
            alt="AI Assistant"
            sx={{
              zIndex: 1,
              animation: `${fadeIn} 1s ease-out 0.3s both`,
            }}
          />
        )}
      </Box>

      <Typography variant="captionSecondary">
        Your summary will be generated soon, and we'll notify you as soon as it's ready for review.
      </Typography>
    </Stack>
  );
};

export default GeneratingIndicator;
